import {
  buttonDisabled,
  buttonFocus,
  mediaQuery,
} from "shared/styles/mixins"
import styled from "styled-components"

export const StandardButton = styled.button`
  appearance: none;
  border: none;
  line-height: normal;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  -webkit-tap-highlight-color: transparent;
  height: ${(props) => props.theme.input.height};
  width: ${(props) => props.theme.input.height};

  background-color: ${(props) => props.theme.nonAccentButton.bgColor};
  z-index: ${(props) => props.theme.zIndex.interactiveButton};
  pointer-events: auto;

  svg {
    fill: white;
    stroke: white;
    height: 36px;
    width: 36px;
  }

  ${buttonFocus}

  ${buttonDisabled}

  ${mediaQuery.mobileDevice} {
    height: ${(props) => props.theme.mobile.input.height};
    width: ${(props) => props.theme.mobile.input.height};
  }
`
